import { localStorageLabels } from '../constants';

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
};
export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};

export const clearLocalStorage = (key) => {
  return localStorage.removeItem(key);
};

export const logoutServices = () => {
  Object.values(localStorageLabels).forEach((key) => {
    clearLocalStorage(key);
  });
};

export const syncStorageIntoStateService = (key) => {
  switch (key) {
    case localStorageLabels.TID:
      return getLocalStorage(key) || null;
    default: {
      const data = getLocalStorage(key);
      return data ? JSON.parse(data) : null;
    }
  }
};

export const syncStateIntoStorageService = ({ value, key }) => {
  switch (key) {
    case localStorageLabels.TID:
      return setLocalStorage(key, value);
    default:
      return setLocalStorage(key, JSON.stringify(value));
  }
};
